import React, { useContext } from 'react';
import { BaseContext } from '../contexts';
import { plansPageUpdateDimensions } from '../statistics';

const PlansListStatistics = ({ children }) => {
  const { plansLastElRef, scrollPlansEls } = useContext(BaseContext);
  const lasElementRefCallback = (el) => {
    plansLastElRef.current = el;
    plansPageUpdateDimensions(plansLastElRef, scrollPlansEls);
  };

  return (
    <>
      { children }
      <div className="last-element" ref={ lasElementRefCallback } />
    </>
  );
};

export default PlansListStatistics;
